<template>
    <section class="login">
        <div class="container-scroller forgot-container-scroller">
            <div class="container-fluid page-body-wrapper full-page-wrapper forgot-full-page-wrapper">
                <div class="content-wrapper d-flex align-items-center auth forgot-content-wrapper reset-content-wrapper">
                    <div class="row w-100 flex-grow">
                        <div class="col-xl-4 col-lg-6 mx-auto">
                            <div class="auth-form-light text-left">
                                <div class="brand-logo text-center">
                                     <router-link to="/">
                                        <img src="../public/assets/images/Vanovy-Logo.svg" alt="Vanovy Logo" />
                                    </router-link>
                                </div>
                                <div class="auth-form">
                                    <form class="pt-3">
                                        <b-form-group id="input-group-1" label="Email Address" label-for="input-1">
                                            <b-form-input id="input-1" type="email" placeholder="Email Address"
                                                v-model="$v.email.$model"
                                                :state="$v.email.$dirty ? !$v.email.$error : null"
                                                aria-describedby="input-2-live-feedback"></b-form-input>
                                            <b-form-invalid-feedback v-if="!$v.email.required"
                                                id="input-2-live-feedback">This is a required field.
                                            </b-form-invalid-feedback>
                                            <b-form-invalid-feedback v-if="!$v.email.email" id="input-2-live-feedback">
                                                Invalid Email.
                                            </b-form-invalid-feedback>

                                        </b-form-group>
                                        <b-form-group id="input-group-2" label="Password" label-for="input-2">
                                            <span class="icon is-small is-right" style="">
                                                <b-form-input id="input-2" :type="inputType" placeholder="Password"
                                                    v-model="$v.password.$model"
                                                    :state="$v.password.$dirty ? !$v.password.$error : null"
                                                    aria-describedby="input-3-live-feedback"></b-form-input>
                                                <b-form-invalid-feedback v-if="!$v.password.required"
                                                    id="input-3-live-feedback">This is a required
                                                    field.</b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="!$v.password.minLength"
                                                    id="input-3-live-feedback">Password must have at least {{
                                                        $v.password.$params.minLength.min }}
                                                    letters.</b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="password && !$v.password.valid"
                                                    id="input-3-live-feedback">Password contains atleast One Uppercase,
                                                    One Lowercase, One Number and One Special
                                                    Chacter.</b-form-invalid-feedback>
                                                <i @click="toggleShow" class="fas password-icon"
                                                    :class="{ 'fa fa-eye': showPassword, 'fa fa-eye-slash': !showPassword, }"></i></span>

                                        </b-form-group>
                                        <b-form-group id="input-group-4" label="Confirm Password" label-for="input-4">
                                            <span class="icon is-small is-right" style="">
                                                <b-form-input id="input-4" :type="inputType1"
                                                    placeholder="Confirm Password"
                                                    v-model="$v.password_confirmation.$model"
                                                    :state="$v.password_confirmation.$dirty ? !$v.password_confirmation.$error : null"
                                                    aria-describedby="input-4-live-feedback"></b-form-input>
                                                <b-form-invalid-feedback v-if="!$v.password_confirmation.required"
                                                    id="input-3-live-feedback">This is a required
                                                    field.</b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="!$v.password_confirmation.sameAsPassword"
                                                    id="input-4-live-feedback">Passwords must be
                                                    identical.</b-form-invalid-feedback>
                                                <i @click="toggleConfirmShow" class="fas password-icon"
                                                    :class="{ 'fa fa-eye': showPassword1, 'fa fa-eye-slash': !showPassword1, }"></i></span>

                                        </b-form-group>
                                        <div class="mt-3">
                                            <button type="button" class="btn btn-primary btn-block btn-lg waves-effect waves-light cursor-pointer"
                                                :disabled="this.$v.email.$anyError || this.$v.password.$anyError || this.isDisabled"
                                                @click="login()">Submit
                                            </button>
                                        </div>
                                        <div class="mt-3">
                                            <div class="social-login text-center">
                                                <router-link class="btn router-link-active" to="/">
                                                    <i class="fa fa-arrow-left m-right-5"></i><span>Back to Login</span>
                                                </router-link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
        <div class="col-md-4 col-sm-6 grid-margin stretch-card" v-if="isHide">
            <div class="loader-demo-box">
                <div class="dot-opacity-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import router from "../router"
import API from '@/api'
import Footer from "../layout/partials/Footer";
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import Vue from "vue";
import Snotify, { SnotifyPosition } from "vue-snotify";
const options = {
    toast: {
        timeout: 2000,
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)
export default {
    name: "Reset-Password",
    mixins: [validationMixin],
    components: {
        Footer
    },
    data() {
        return {
            email: '',
            password: '',
            password_confirmation: '',
            disabled: '',
            remember_be: '',
            token: '',
            showPassword: true,
            showPassword1: true,
            isDisabled: false,
            inputType: 'password',
            inputType1: 'password',
        };
    }, validations: {
        email: {
            email,
            required,
        }, password: {
            required,
            minLength: minLength(6),
            valid: function (value) {
                const containsUppercase = /[A-Z]/.test(value)
                const containsLowercase = /[a-z]/.test(value)
                const containsNumber = /[0-9]/.test(value)
                const containsSpecial = /[#?!@$%^&*-]/.test(value)
                return containsUppercase && containsLowercase && containsNumber && containsSpecial
            },
        }, password_confirmation: {
            required,
            sameAsPassword: sameAs('password')
        }
    },

    methods: {
        login() {
            this.isDisabled = true;
            this.$v.email.$touch();
            this.$v.password.$touch();
            this.$v.password_confirmation.$touch();

            if (this.$v.email.$anyError || this.$v.password.$anyError || this.$v.password_confirmation.$anyError) {
                this.isDisabled = false;
                return;
            }

            const data = {
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                token: this.token
            };

            API.resetPassword(
                data,
                response => {
                    this.isDisabled = false;

                    if (response.status === 200 || response.message === "Password reset successful.") {
                        this.$swal({
                            type: 'success',
                            icon: 'success',
                            title: 'Success',
                            text: response.message
                        });

                        setTimeout(() => {
                            router.push('/');
                        }, 1000);
                    } else {
                        this.$swal({
                            type: 'error',
                            icon: 'error',
                            title: 'Oops...',
                            text: response.message || 'Something went wrong.'
                        });
                    }
                },
                error => {
                    this.isDisabled = false;

                    if (error.response && error.response.status === 422) {
                        const errors = error.response.data.errors;
                        const messages = Object.values(errors).flat().join('\n');

                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: 'Validation Error',
                            text: messages
                        });
                    } else {
                        // General error fallback
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: error.response?.data?.message || 'An unexpected error occurred.'
                        });
                    }
                }
            );
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
            if (this.showPassword) {
                this.inputType = 'password';
            } else {
                this.inputType = 'text';
            }
        }, toggleConfirmShow() {
            this.showPassword1 = !this.showPassword1;
            if (this.showPassword1) {
                this.inputType1 = 'password';
            } else {
                this.inputType1 = 'text';
            }
        }
    },
    mounted() {
        this.token = this.$route.params.token;
    }
}
</script>
